import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=285e331f&scoped=true&"
import script from "./DefaultContainer.vue?vue&type=script&lang=ts&"
export * from "./DefaultContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=285e331f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e331f",
  null
  
)

export default component.exports